/* eslint-disable camelcase */
interface ProductTypes {
  is_interested_in_bras?: boolean;
  is_interested_in_bralettes?: boolean;
  is_interested_in_undies?: boolean;
}

type Step = 'bra' | 'bralette' | 'undie';

interface Args {
  productTypes: ProductTypes;
  isEditing: boolean;
}

export const getQuizSizeSteps = ({ productTypes, isEditing }: Args) => {
  const steps: Step[] = [];

  const isInterestedInBoxers = Object.entries(productTypes).some(
    ([key, isInterested]) =>
      key.startsWith('is_interested_in_boxers') && isInterested
  );

  const notInterested =
    !productTypes.is_interested_in_bras &&
    !productTypes.is_interested_in_bralettes &&
    !productTypes.is_interested_in_undies &&
    !isInterestedInBoxers &&
    !isEditing;

  if (notInterested) {
    return [];
  }

  if (isEditing || productTypes.is_interested_in_bras) {
    steps.push('bra');
  }

  if (isEditing || productTypes.is_interested_in_bralettes) {
    steps.push('bralette');
  }

  if (
    isEditing ||
    productTypes.is_interested_in_undies ||
    isInterestedInBoxers
  ) {
    steps.push('undie');
  }

  return steps;
};
